import * as types from '../mutation-types'

const state = {
  progressPercentage: 0,
  progressVisible: false
}


const getters = {
  progressPercentage: state => state.progressPercentage,
  progressVisible: state => state.progressVisible
}


const actions = {

  showProgress(context) {
    actions.setProgressVisible(context,true);
    setInterval(() => {
      actions.setProgressPercentage(context,state.progressPercentage + 1);
    }, Math.floor(Math.random()*100));
  },
  hideProgress(context){
    actions.setProgressPercentage(context,0);
    actions.setProgressVisible(context,false);
  },


  setProgressPercentage(context,progressPercentage) {
    context.commit(types.PROGRESS_PERCENTAGE_CHANGE, progressPercentage)
  },
  setProgressVisible(context,progressVisible){
    context.commit(types.PROGRESS_VISIBLE_CHANGE, progressVisible)
  }
}

const mutations = {
  [types.PROGRESS_PERCENTAGE_CHANGE](state, progressPercentage) {
      state.progressPercentage = progressPercentage
  },
  [types.PROGRESS_VISIBLE_CHANGE](state, progressVisible) {
      state.progressVisible = progressVisible
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}